import * as React from "react";
import { styled, SxProps, Typography, Stack, Divider, Box, BoxProps } from "@mui/material";

export type BoxPaperProps = {
  sx?: SxProps;
  className?: string;
  title: string;
  rightContent?: React.ReactNode;
  children?: React.ReactNode;
} & BoxProps;

const BoxPaper: React.FC<BoxPaperProps> = (props) => {
  const { title, rightContent, children, ...otherProps } = props;

  return (
    <StyledBoxPaper {...otherProps}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h5">{title}</Typography>
        {rightContent}
      </Stack>
      <Divider sx={{ mt: 2, mb: 2 }} />
      {children}
    </StyledBoxPaper>
  );
};

export default BoxPaper;

const StyledBoxPaper = styled(Box)(({ theme }) => ({
  borderRadius: 12,
  background: theme.palette.background.paper,
  boxShadow: "none",
  overflow: "hidden",
  padding: `16px 20px`,
}));
